import moment from 'moment';

export function formatTime(time: string) {
  return moment(time, 'HH:mm:ss').format('hh:mm a');
}
